export default __webpack_public_path__ + "static/media/icon4.12417159.svg";